import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RequestApprovalConfigDto } from '../models/RequestApprovalConfigDto';
import { ApiResponseObject } from '../models/responses/api-response-object';

@Injectable({
  providedIn: 'root'
})
export class RequestapprovalconfigsService {

  constructor(private httpClient: HttpClient) { }
  getApprovalLevels(): Observable<ApiResponseObject<RequestApprovalConfigDto[]>> {
    return this.httpClient.get<ApiResponseObject<RequestApprovalConfigDto[]>>(`${environment.apiUrl}/RequestTypeConfigurations`);
  }
}
